import { ReactNode } from 'react';
import { envConfig } from '@/config/envConfig';
import { CheckoutProvider } from '@stripe/react-stripe-js';
import { useMutation } from '@tanstack/react-query';
import { createSubscriptionCheckoutSession } from '../api';
import { CreateSubscriptionCheckoutSessionPayloadType } from '@/api/v1/billing/createSubscriptionCheckoutSessionApi';
import { showSnackbarResponseError } from '@/helpers/helpers';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(envConfig.STRIPE_API_KEY, {
  developerTools: { assistant: { enabled: envConfig.IS_DEVELOPMENT || envConfig.IS_STAGING } },
});

type SubscriptionCheckoutProviderType = {
  planId: string;
  children: ReactNode;
  onError: () => void;
};

export const SubscriptionCheckoutProvider = ({ planId, children, onError }: SubscriptionCheckoutProviderType) => {
  const { mutateAsync } = useMutation({
    mutationKey: ['create_subscription_checkout_session'],
    mutationFn: () => {
      const payload: CreateSubscriptionCheckoutSessionPayloadType = {
        plan_id: planId,
        ui_mode: 'custom',
        return_url: window.location.href,
      };

      return createSubscriptionCheckoutSession(payload);
    },
  });

  const fetchClientSecret = async () => {
    return mutateAsync().then((response) => {
      if (response?.error) {
        showSnackbarResponseError(response?.error);
        onError();

        return '';
      }

      return response?.body?.client_secret;
    });
  };

  return (
    <CheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
      {children}
    </CheckoutProvider>
  );
};
